module.exports = __webpack_public_path__ + "img/arrow.54d32401.png";